var defaultModel = {
  ariaHidden: true,
  title: 'Confirm',
  message: 'Are you sure you want to proceed?',
  cancelLabel: 'Cancel',
  confirmLabel: 'Confirm',
  loadingLabel: 'Confirming...',
  cancellingLabel: 'Canelling...',
  showCancelLabel: true,
  allowClose: false,
  showContactUs: false,
  useSameButtons: false,
  isSaving: false,
  isCancelling: false,
  useLoading: false
};

var ConfirmationForm = Backbone.Epoxy.View.extend({
  template: 'modals.confirmationForm',

  events: {
    'click #confirmModalIgnore': 'callIgnore',
    'click #confirmModalSave': 'callSave'
  },

  initialize: function() {
    this.hasRendered = false;
    this.model = new Backbone.Model(defaultModel);
  },


  beforeRender: function() {
    if (this.hasRendered) {
      return false;
    }
    this.hasRendered = true;
    return true;
  },

  /**
   * Boilerplate after render for modals.
   */
  afterRender: function() {
    this.$el.modal({
      show: false
    });

    this.$el.on('hide.bs.modal', _.bind(function(e){
      $('#modal').attr("aria-hidden", "true");     
      $('#confirmation-modal').attr('aria-hidden', 'true');
      if ('parentIFrame' in window) {
        parentIFrame.sendMessage({event: 'closeModal'});
        $('body').css('background', 'transparent');
      } else {
        console.log('No parent, oh noes')
      }
    }, this));

    this.$el.on('show.bs.modal', function (e) {
      $('#modal').attr("aria-hidden", "false");
      $('#confirmation-modal').attr('aria-hidden', 'false');
    });

    this.applyBindings();
  },

  cleanup: function() {
    this.removeBindings();
  },

  callSave: function () {
    if (this.saveFunction) {
      if (this.model.get('useLoading')){
        this.model.set('isSaving', true);
        this.saveFunction(_.bind(function() {
          this.model.set('isSaving', false);
          this.$el.modal('hide');
          $('#modal').css('display', 'none');
        }, this));
      } else {
        this.saveFunction();
        this.$el.modal('hide');
        $('#modal').css('display', 'none');
      }
    } else {
      this.$el.modal('hide');
      $('#modal').css('display', 'none');
    }
  },

  callIgnore: function () {
    if (this.ignoreFunction) {
      if (this.model.get('useLoading') && this.model.get('useSameButtons')){
        this.model.set('isCancelling', true);
        this.ignoreFunction(_.bind(function() {
          this.model.set('isCancelling', false);
          this.$el.modal('hide');
          $('#modal').css('display', 'none');
        }, this));
      } else {
        this.ignoreFunction();
        this.$el.modal('hide');
        $('#modal').css('display', 'none');
      }
    } else {
      this.$el.modal('hide');
      $('#modal').css('display', 'none');
    }
  },

  /**
   * Show this form.
   */
  show: function(confirm, ignore, options) {
    this.model.set(defaultModel);
    this.model.set(options);
    this.saveFunction = confirm;
    this.ignoreFunction = ignore;

    this.$el.modal('show');
    if ('parentIFrame' in window) {
      parentIFrame.sendMessage({event: 'openModal'});
      $('body').css('background', '#fbfbfb');
      //$('.modal-backdrop').hide();
    } else {
      console.log('No parent, oh noes')
    }
  }

});

module.exports = ConfirmationForm;